import React from "react";
import i18n from "../../i18n";

export class TestimonialSlider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: 0,
      isTransitioning: false,
      itemsPerSlide: this.getItemsPerSlide() // ✅ dynamic per screen size
    };
    
    this.testimonials = 
    [
  {
    id: 1,
    name: "Aisha Al-Harthy",
    position: "Small Business Owner, Muscat",
    image: "https://example.com/images/aisha.jpg",
    text: "Mzadcom completely transformed how I sell my inventory. What used to take days of organizing physical auctions now happens smoothly online. The reach and visibility are unmatched across Oman.",
    rating: 5
  },
  {
    id: 2,
    name: "Hamed bin Saif",
    position: "Procurement Manager, IndustrialCo",
    image: "https://example.com/images/hamed.jpg",
    text: "We needed a reliable and transparent auction platform for heavy equipment. Mzadcom’s timed auctions and detailed listings with lot previews made it easy to decide before bidding. Highly recommended.",
    rating: 5
  },
  {
    id: 3,
    name: "Fatima Al-Rashdi",
    position: "Freelancer & Collector, Salalah",
    image: "https://example.com/images/fatima.jpg",
    text: "As someone who’s far from Muscat, the website  changed everything. I can preview items, place a bid, and track auctions from my phone. No more travelling just to view items!",
    rating: 5
  },
  {
    id: 4,
    name: "Omar Al-Maawali",
    position: "Dealership Owner, Sohar",
    image: "https://example.com/images/omar.jpg",
    text: "Mzadcom’s payment guarantees and deposit system give confidence. Both buyers and sellers are protected, and that’s rare in auction business. Their support has been outstanding too.",
    rating: 5
  },
  {
    id: 5,
    name: "Layla Al-Lawati",
    position: "Digital Marketer, Muscat",
    image: "https://example.com/images/layla.jpg",
    text: "I love how quick and easy the bidding process is with Mzadcom. The lot images, condition details, and customer service saved me time and ensured I make informed decisions.",
    rating: 5
  }
]
}

getItemsPerSlide = () => {
    if (window.innerWidth < 576) return 1; // mobile
    if (window.innerWidth < 992) return 2; // tablet
    return 3; // desktop
  };

  componentDidMount() {
    // Auto-slide
    this.slideInterval = setInterval(() => {
      this.nextSlide();
    }, 5000);

    // ✅ Listen for window resize
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    if (this.slideInterval) clearInterval(this.slideInterval);
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    this.setState({ itemsPerSlide: this.getItemsPerSlide() });
  };

  nextSlide = () => {
    if (this.state.isTransitioning) return;
    this.setState({ isTransitioning: true });
    setTimeout(() => {
      const { currentIndex } = this.state;
      const maxIndex = Math.max(0, this.testimonials.length - this.state.itemsPerSlide);
      this.setState({
        currentIndex: currentIndex >= maxIndex ? 0 : currentIndex + 1,
        isTransitioning: false
      });
    }, 300);
  };

  prevSlide = () => {
    if (this.state.isTransitioning) return;
    this.setState({ isTransitioning: true });
    setTimeout(() => {
      const { currentIndex } = this.state;
      const maxIndex = Math.max(0, this.testimonials.length - this.state.itemsPerSlide);
      this.setState({
        currentIndex: currentIndex <= 0 ? maxIndex : currentIndex - 1,
        isTransitioning: false
      });
    }, 300);
  };

  renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <i
        key={i}
        className={`fas fa-star ${i < rating ? "text-warning" : "text-light"}`}
        style={{ fontSize: "0.9rem", marginRight: "1px" }}
      ></i>
    ));
  };

  render() {
    const { currentIndex, isTransitioning, itemsPerSlide } = this.state;
    const maxIndex = Math.max(0, this.testimonials.length - itemsPerSlide);

    let visibleTestimonials = this.testimonials.slice(
      currentIndex,
      currentIndex + itemsPerSlide
    );

    while (
      visibleTestimonials.length < itemsPerSlide &&
      this.testimonials.length >= itemsPerSlide
    ) {
      const remaining = itemsPerSlide - visibleTestimonials.length;
      visibleTestimonials.push(...this.testimonials.slice(0, remaining));
    }

    return (
      <section className="testimonial-section py-5 bg-light" id="testimonials">
        <div className="container">
          {/* Header */}
          <div className="row mb-5">
            <div className="col-12 text-center">
              <h2 className="display-5 fw-bold text-dark mb-3">
                {i18n.t("what_our_clients_say")}
              </h2>
              <p
                className="lead text-muted mb-0 mx-auto"
                style={{ maxWidth: "600px" }}
              >
                {i18n.t("desc_wocs")}
              </p>
            </div>
          </div>

          {/* Slider */}
          <div className="position-relative">
            <div className="testimonial-slider-wrapper overflow-hidden">
              <div
                className={`d-flex transition-transform ${
                  isTransitioning ? "opacity-75" : ""
                }`}
                style={{
                  transform: `translateX(0)`,
                  transition: isTransitioning ? "opacity 0.3s ease" : "none"
                }}
              >
                {visibleTestimonials.map((testimonial, index) => (
                  <div
                    key={`${testimonial.id}-${currentIndex}-${index}`}
                    className="flex-shrink-0 px-2"
                    style={{ width: `${100 / itemsPerSlide}%` }} // ✅ width auto-adjust
                  >
                    <div className="testimonial-card bg-white rounded-4 shadow-sm h-100 p-4 border-0 position-relative overflow-hidden">
                      {/* Quote */}
                      <div className="mb-3">
                        <i
                          className="fas fa-quote-left"
                          style={{
                            fontSize: "1.5rem",
                            background:
                              "linear-gradient(135deg, #189397 0%, #bdc532 100%)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            backgroundClip: "text"
                          }}
                        ></i>
                      </div>

                      {/* Rating */}
                      <div className="mb-3">{this.renderStars(testimonial.rating)}</div>

                      {/* Text */}
                      <blockquote className="mb-4">
                        <p
                          className="text-dark mb-0 lh-base"
                          style={{ fontSize: "0.95rem", fontStyle: "italic" }}
                        >
                          "{testimonial.text}"
                        </p>
                      </blockquote>

                      {/* User */}
                      <div className="d-flex align-items-center mt-auto">
                        <div className="p-2">
                          <h6
                            className="mb-1 fw-bold text-dark"
                            style={{ fontSize: "0.9rem" }}
                          >
                            {testimonial.name}
                          </h6>
                          <p className="mb-0 text-muted small">
                            {testimonial.position}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Arrows */}
            {this.testimonials.length > itemsPerSlide && (
              <>
                <button
                  className="btn btn-primary rounded-circle position-absolute top-50 start-0 translate-middle-y shadow-sm d-none d-md-flex align-items-center justify-content-center"
                  onClick={this.prevSlide}
                  style={{
                    width: "45px",
                    height: "45px",
                    marginLeft: "-22px",
                    zIndex: 10,
                    background:
                      "linear-gradient(135deg, #189397 0%, #bdc532 100%)",
                    border: "none"
                  }}
                  disabled={isTransitioning}
                >
                  <i className="fas fa-chevron-left text-white"></i>
                </button>

                <button
                  className="btn btn-primary rounded-circle position-absolute top-50 end-0 translate-middle-y shadow-sm d-none d-md-flex align-items-center justify-content-center"
                  onClick={this.nextSlide}
                  style={{
                    width: "45px",
                    height: "45px",
                    marginRight: "-22px",
                    zIndex: 10,
                    background:
                      "linear-gradient(135deg, #189397 0%, #bdc532 100%)",
                    border: "none"
                  }}
                  disabled={isTransitioning}
                >
                  <i className="fas fa-chevron-right text-white"></i>
                </button>
              </>
            )}
          </div>

          {/* Dots */}
          {this.testimonials.length > itemsPerSlide && (
            <div className="text-center mt-4">
              <div className="d-inline-flex gap-2">
                {Array.from({ length: maxIndex + 1 }, (_, index) => (
                  <button
                    key={index}
                    className={`btn rounded-circle p-0 border-0 ${
                      index === currentIndex ? "opacity-100" : "opacity-50"
                    }`}
                    onClick={() =>
                      !isTransitioning &&
                      this.setState({ currentIndex: index })
                    }
                    style={{
                      width: "10px",
                      height: "10px",
                      background:
                        "linear-gradient(135deg, #189397 0%, #bdc532 100%)",
                      transition: "all 0.3s ease"
                    }}
                    disabled={isTransitioning}
                  ></button>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* FontAwesome */}
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
        />
      </section>
    );
  }
}